import { VivelaIconName } from '../icon/types';

export type ListItem = {
  icon?: VivelaIconName;
  itemName: string;
  itemValue: string | number | boolean;
  type?: 'string' | 'boolean';
};
